import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";

export default class UpdateCategory extends Component {
  state = {
    name: "",
  };
  componentDidMount() {
    this.getCategory();
  }
  getCategory = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("categoryId", this.props.match.params.category_id);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        this.setState({
          name: data.name,
          discription: data.description,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  UpdateCategory = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("name", this.state.name);
    urlencoded.append("description", this.state.discription);
    urlencoded.append("categoryId", this.props.match.params.category_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.location.href = "#/admin/categories/";
      })
      .catch((error) => console.log("error", error));
  };

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/categories">Categories</Link> /{" "}
                  <b> Add Category</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Category Name"
                  id="inputDefault"
                  name="name"
                  value={this.state.name}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Description
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Discription"
                  id="inputDefault"
                  name="discription"
                  value={this.state.discription}
                  onChange={this.onInputChange}
                />
              </div>
            </div>
          </div>
          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.UpdateCategory}>
              {" "}
              Save
            </div>{" "}
            or  <Link to="/admin/categories" className="btn-link">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}
